import { render, staticRenderFns } from "./CaseDetailPanel.vue?vue&type=template&id=4349c37c&scoped=true&"
import script from "./CaseDetailPanel.vue?vue&type=script&lang=js&"
export * from "./CaseDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetailPanel.vue?vue&type=style&index=0&id=4349c37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4349c37c",
  null
  
)

export default component.exports